module.exports = __webpack_public_path__ + "img/bpr_beeparktoken.5a93cb0.png";